import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { Row, Col} from 'react-bootstrap';
import { Button, Table, TableBody, TableCell, TableContainer, TableRow, Chip } from '@mui/material';
import { useEffect } from "react";
import { getGatewaysById, getSensorsById } from "components/axios/iotAxios";
import { useState } from "react";
import dayjs from "dayjs";
import { getEquipmentsById } from "components/axios/equipmentAxios";
import { useEnumApi } from "contexts/EnumApiContext";

const SensorViewSetting = () => {
  const { getEnumValueByEnumNameAndCode } = useEnumApi();
  const { t } = useTranslation();

  const {id} = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [sensor, setSensor] = useState({});
  const [gateways, setGateways] = useState([]);
  const [equipments, setEquipments] = useState([]);
  const connectProblemDay = dayjs(new Date()).subtract(7, "d").format("YYYY-MM-DD");
  const today = new Date();

  useEffect(()=>{
    if (!isLoading) {
      Promise.all([
        getSensorsById(id).then((res)=>{
          setSensor(res);
          return res;
        })
      ]).then((res2)=>{
        if (res2[0]) {
          if (res2[0].gateway) {
            getGatewaysById(res2[0].gateway.id).then((res3)=>{
              setGateways([res3]);
            });
          }
          if (res2[0].equipmentPart) {
            getEquipmentsById(res2[0].equipmentPart.equipment.id).then((res4)=>{
              setEquipments([res4]);
            });
          }
          setIsLoading(true);
        }
      })
    }
  },[isLoading, id]);

  if (isLoading && sensor) {
      let connectProblemColor = "view_td2";
      let diffDate = 0;
      if (sensor.latestCommedAt) {
        if (sensor.latestCommedAt && dayjs(sensor.latestCommedAt).format('YYYY-MM-DD') < connectProblemDay) {
            connectProblemColor = "view_td2 red";
        }
        diffDate = ((today.getTime() - new Date(sensor.latestCommedAt).getTime()) / (24*60*60*1000)).toFixed(0);
      } else {
        connectProblemColor = "view_td2 red";
      }

      return (
      <div style={{padding:"15px 0"}}>
          <Row>
            <Col sm={8} className="main_left">
              <div style={{marginBottom:"10px"}}>
                  <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;
                  <Chip label={t('message.common.title.sensor.information')} style={{color:"#fff", backgroundColor:"#6a7075", borderRadius:"4px"}} />
              </div>
  
              <TableContainer key={0}>
                <Table sx={{ minWidth: 1000 }} aria-label="simple table" className="same_width view_table" style={{borderTop:"2px solid #a2a2a2"}} >
                  <TableBody>
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.manufacturing.company')}</TableCell>
                      <TableCell className="view_td2">
                        {/* {sensor.madeBy && getEnumValueByEnumNameAndCode("SensorMF", sensor.madeBy) && getEnumValueByEnumNameAndCode("SensorMF", sensor.madeBy)[0]?.title}&nbsp; */}
                        {sensor.madeBy}
                      </TableCell>
                      <TableCell className="th">S/N</TableCell>
                      <TableCell className="view_td2">{sensor.sn}&nbsp;</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.installation.location')}(X, Y, Z)</TableCell>
                      <TableCell className="">
                        {sensor.axial && getEnumValueByEnumNameAndCode("SensorDirection", sensor.axial) && getEnumValueByEnumNameAndCode("SensorDirection", sensor.axial)[0].title}
                        {sensor.radial && getEnumValueByEnumNameAndCode("SensorDirection", sensor.radial) && ', '+getEnumValueByEnumNameAndCode("SensorDirection", sensor.radial)[0].title}
                        {sensor.vertical && getEnumValueByEnumNameAndCode("SensorDirection", sensor.vertical) && ', '+getEnumValueByEnumNameAndCode("SensorDirection", sensor.vertical)[0].title}
                        &nbsp;
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.installation.date')}</TableCell>
                      <TableCell className="view_td2">{sensor.instlYmd}&nbsp;</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.last.communication')}</TableCell>
                      <TableCell className={connectProblemColor}>{sensor.latestCommedAt && diffDate+t('message.common.text.day.ago')}&nbsp;</TableCell>
                      <TableCell className="th"></TableCell>
                      <TableCell className="view_td2"></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
  
              <br/>
              <div style={{marginBottom:"10px"}}>
                  <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;
                  <Chip label={t('message.common.title.connection.gateway')} style={{color:"#fff", backgroundColor:"#6a7075", borderRadius:"4px"}} />
              </div>

              <TableContainer key={2}>
                <Table className="list_table" sx={{ minWidth: 400 }} aria-label="simple table" style={{borderTop:"2px solid #a2a2a2"}}>
                  <TableBody>
                    <TableRow>
                      <TableCell className="th">No.</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.manufacturing.company')}</TableCell>
                      <TableCell className="th">S/N</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.last.communication')}</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.installation.date')}</TableCell>
                    </TableRow>
                    { gateways && gateways.map(function(con, i) {
                      connectProblemColor = "view_td2";
                      if (gateways[i].latestCommedAt) {
                        if (gateways[i].latestCommedAt && gateways[i].latestCommedAt < connectProblemDay) {
                            connectProblemColor = "view_td2 red";
                        }
                        diffDate = ((today.getTime() - new Date(gateways[i].latestCommedAt).getTime()) / (24*60*60*1000)).toFixed(0);
                      } else {
                        connectProblemColor = "view_td2 red";
                      }
                      return(
                    <TableRow key={i}>
                      <TableCell align="center">{gateways.length-i}</TableCell>
                      {/* <TableCell align="center">{gateways[i].madeBy && getEnumValueByEnumNameAndCode("GatewayMF", gateways[i].madeBy) && getEnumValueByEnumNameAndCode("GatewayMF", gateways[i].madeBy)[0].title}</TableCell> */}
                      <TableCell align="center">{gateways[i].madeBy}</TableCell>
                      <TableCell align="center">{gateways[i].sn}</TableCell>
                      <TableCell align="center" className={connectProblemColor}>{gateways[i].latestCommedAt && diffDate+t('message.common.text.day.ago')}</TableCell>
                      <TableCell align="center">{gateways[i].instlYmd}</TableCell>
                    </TableRow>
                      )
                  }) }
                  </TableBody>
                </Table>
              </TableContainer>

              <div style={{marginTop:"10px"}}>
                  <Link to={'../'+window.location.search}><Button variant="contained" color="primary">{t('message.common.btn.list')}</Button></Link>
              </div>
            </Col>
  
            <Col sm={4} className="main_right">
              <div style={{marginBottom:"10px"}}>
                  <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;
                  <Chip label={t('message.common.title.target.equipment.information')} style={{color:"#fff", backgroundColor:"#6a7075", borderRadius:"4px"}} />
              </div>
  
              { equipments && equipments.map(function(con, i) {
                  return(
              <TableContainer key={i}>
                <Table sx={{ minWidth: 400 }} aria-label="simple table" className="same_width view_table" style={{borderTop:"2px solid #a2a2a2"}} >
                  <TableBody>
                    {/* <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.subwayline')}</TableCell>
                      <TableCell className="view_td">
                        {equipments[i].station && equipments[i].station.workingPart && equipments[i].station.workingPart.subwayLine && getEnumValueByEnumNameAndCode("SubwayLine", equipments[i].station.workingPart.subwayLine) && getEnumValueByEnumNameAndCode("SubwayLine", equipments[i].station.workingPart.subwayLine)[0].title}
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.workingPart')}</TableCell>
                      <TableCell className="view_td">
                        {equipments[i].station && equipments[i].station.workingPart && equipments[i].station.workingPart.name}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.station')}</TableCell>
                      <TableCell className="view_td" colSpan={3}>
                        {equipments[i].station && equipments[i].station.name}
                      </TableCell>
                    </TableRow> */}
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.equipment.name')}</TableCell>
                      <TableCell className="view_td" colSpan={3}>
                        {equipments[i].name}({equipments[i].equipmentNo})
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
                  )
              })}
            </Col>
          </Row>
      </div>
      )
  }
}

export default SensorViewSetting;